import React from 'react';
import styles from "./Loading.module.scss";

const Loading = (props) => {

    return (
        <div className={styles.container}>
            <div className={styles.spinner} style={{
                width: props.size ? props.size + 'px' : '30px',
                height: props.size ? props.size + 'px' : '30px',
                color: props.color || '#32CCCC',

            }}>
                <svg className="" viewBox="22 22 44 44">
                    <circle className="" cx="44" cy="44"
                            r="20.2" fill="none" strokeWidth="3.6"></circle>
                </svg>
            </div>

        </div>
    );

};

export default Loading;